import { useState, useEffect } from 'react'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Form } from 'util/ui'
import { SVGIcon } from 'shared/ui'
import GA from 'util/googleAnalytics'
import themeVars from 'ui_theme/site/globals/site.variables'

const Button = styled(Form.Button)`
  position: relative;
  & button {
    font-family: ${themeVars.graphik} !important;
    font-size: ${props => props.theme.spacing['10']} !important;
    line-height: 1 !important;
    padding-top: ${themeVars.relative15px} !important;
    padding-bottom: ${themeVars.relative15px} !important;
  }
`

const Icon = styled(SVGIcon)`
  position: absolute;
  left: ${props => props.theme.spacing['10']};
  top: ${themeVars.relative12px};
`

const buttonSpanStyle = () => theme => css`
  &&& {
    color: ${theme.color.monochrome.dark} !important;
  }
`

const OAuthButton = ({
  onClick,
  iconName,
  disabled = false,
  saving = false,
  text = '',
  savingText = '',
  tracking,
}) => {
  const [clicked, setClicked] = useState(false)
  useEffect(
    () => {
      if (saving === false && clicked) {
        setClicked(false)
      }
    },
    [saving, clicked]
  )
  return (
    <Button
      size="big"
      fluid
      disabled={disabled || saving}
      // eslint-disable-next-line react/jsx-no-bind
      onClick={() => {
        setClicked(true)
        if (tracking) {
          GA.track(tracking.category, tracking.action, tracking.label)
        }
        onClick()
      }}
      basic
    >
      <Icon name={iconName} size={24} />
      <span css={buttonSpanStyle}>
        {clicked && saving && savingText ? savingText : text}
      </span>
    </Button>
  )
}

export default OAuthButton
